<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <!-- <navbar
          is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
          btn-background="bg-gradient-success"
          :dark-mode="true"
        /> -->
      </div>
    </div>
  </div>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain">
                <div class="pb-0 card-header text-start">
                  <h3 class="font-weight-bolder text-success text-gradient">
                    歡迎回來
                  </h3>
                  <p class="mb-0">請輸入您的電子郵件和密碼以登入</p>
                </div>
                <div class="card-body">
                  <form role="form" class="text-start">
                    <label>電子郵件</label>
                    <soft-input
                      id="email"
                      type="email"
                      placeholder="電子郵件"
                      name="email"
                      v-model="email"
                    />
                    <label>密碼</label>
                    <soft-input
                      id="password"
                      type="password"
                      placeholder="密碼"
                      name="password"
                      v-model="password"
                    />
                    <soft-switch id="rememberMe" name="rememberMe" checked>
                      記住我
                    </soft-switch>
                    <div class="text-center">
                      <soft-button
                        class="my-4 mb-2"
                        variant="gradient"
                        color="success"
                        full-width
                        @click.prevent="handleLogin"
                        >登入
                      </soft-button>
                    </div>
                  </form>
                </div>
                <div
                  v-if="false"
                  class="px-1 pt-0 text-center card-footer px-lg-2"
                >
                  <p class="mx-auto mb-4 text-sm">
                    還沒有帳號？
                    <router-link
                      :to="{ name: 'Sign Up' }"
                      class="text-success text-gradient font-weight-bold"
                      >註冊</router-link
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8"
              >
                <div
                  class="bg-cover oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6"
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/img/curved-images/curved9.jpg') +
                      ')',
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!-- <app-footer /> -->
</template>

<script>
import SoftInput from "@/components/SoftInput.vue";
import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftButton from "@/components/SoftButton.vue";
import request from "@/utils/request";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "SignIn",
  components: {
    SoftInput,
    SoftSwitch,
    SoftButton,
  },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async handleLogin() {
      try {
        const response = await request.post("/api/login", {
          email: this.email,
          password: this.password,
        });

        if (response.data.access_token) {
          localStorage.setItem("token", response.data.access_token);
          if (response.data.user) {
            const user = response.data.user;
            // Inject permissions from response if available
            if (response.data.permissions) {
              user.permissions = response.data.permissions;
            }
            localStorage.setItem("user", JSON.stringify(user));
          }
          this.$router.push("/dashboard");
        }
      } catch (error) {
        console.error("Login failed", error);
        Swal.fire("錯誤", "登入失敗，請檢查您的憑證。", "error");
      }
    },
  },
};
</script>
